import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Title } from '@/components/Typography';
import { RoundedButton } from '../DeleteModal/styles';
import { CustomImage, CustomModal, CustomTextArea, ImageContainer } from './styles';

const { useWatch } = Form;

interface DescriptionModalProps {
	image: any;
	open: boolean;
	onCancel(): void;
	onConfirm(): void;
}

export function DescriptionModal({ image, open, onCancel, onConfirm }: Readonly<DescriptionModalProps>) {
	const description = useWatch([image.uid, 'image_description']);

	return (
		<CustomModal centered width={480} footer={null} open={open} onCancel={onCancel}>
			<Row gutter={[0, 20]}>
				<Col span={24}>
					<Title level={3}>{I18n.get('Add description')}</Title>
				</Col>
				<Col span={24}>
					<Row justify="center">
						<ImageContainer span={18}>
							<CustomImage src={image.url} preview={false} />
						</ImageContainer>
					</Row>
				</Col>
				<Col span={24}>
					<Form.Item name={[image.uid, 'image_description']}>
						<CustomTextArea
							rows={4}
							showCount
							allowClear
							size="middle"
							maxLength={150}
							placeholder={I18n.get('Image description')}
						/>
					</Form.Item>
				</Col>
				<Col span={24}>
					<Row justify="center" gutter={[20, 0]}>
						<Col>
							<RoundedButton key="back" onClick={onCancel}>
								{I18n.get('Cancel')}
							</RoundedButton>
						</Col>
						<Col>
							<RoundedButton type="primary" disabled={!description} onClick={onConfirm}>
								{I18n.get('Save')}
							</RoundedButton>
						</Col>
					</Row>
				</Col>
			</Row>
		</CustomModal>
	);
}
